import {
  fromSelectValue,
  MultiSelect,
  SELECT_ALL_VALUE,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  FilterBar,
} from '@ideon-api/ideon-ui'
import { AREAS, areaParam, PERIODS, type HistoryParams } from '../../lib/history-filters'

// Param updates for the URL: undefined removes the param. Every filter change resets the page.
export type HistoryFilterChange = { area?: string; set?: string; period?: string; page: 1 }

interface HistoryFiltersProps {
  permissionSets: ReadonlyArray<{ key: string }>
  value: HistoryParams
  onChange: (change: HistoryFilterChange) => void
}

const AREA_OPTIONS = AREAS.map(({ value, label }) => ({ value, label }))

export function HistoryFilters({ permissionSets, value, onChange }: HistoryFiltersProps) {
  return (
    <FilterBar label="History filters">
      <Select
        value={value.set ?? SELECT_ALL_VALUE}
        onValueChange={(v) => onChange({ set: fromSelectValue(v) || undefined, page: 1 })}
      >
        <SelectTrigger aria-label="Permission set" className="w-full sm:w-48">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={SELECT_ALL_VALUE}>All permission sets</SelectItem>
          {permissionSets.map((set) => (
            <SelectItem key={set.key} value={set.key}>
              {set.key}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <MultiSelect
        aria-label="Area"
        placeholder="All areas"
        display="count"
        className="w-full sm:w-64"
        options={AREA_OPTIONS}
        value={value.areas}
        onChange={(selected) => onChange({ area: areaParam(selected), page: 1 })}
      />
      <Select
        value={value.period ?? SELECT_ALL_VALUE}
        onValueChange={(v) => onChange({ period: fromSelectValue(v) || undefined, page: 1 })}
      >
        <SelectTrigger aria-label="Period" className="w-full sm:w-48">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={SELECT_ALL_VALUE}>All time</SelectItem>
          {PERIODS.map((p) => (
            <SelectItem key={p.value} value={p.value}>
              {p.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FilterBar>
  )
}
